import React from "react";
import ReactDOM from "react-dom/client";
import "./utils/authSession";
import App from "./App";
import "./styles/index.css";
import { maybeRedirectToCanonicalHost } from "./utils/canonicalHostRedirect";

const root = ReactDOM.createRoot(document.getElementById("root"));

if (!maybeRedirectToCanonicalHost()) {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
